<template>
  <div>
    <img v-if="start.img" class="start-image" :src="getImgUrl(start.img)" />
    <div class="text-area">
      <h3>{{ start.header }}</h3>
      <custom-paragraph
        class="start-text"
        :text="start.text"
        :link="start.link"
      />
      <div class="button-area">
        <custom-button :text="'Aloita'" @click="$emit('start')" />
      </div>
    </div>
  </div>
</template>

<script>
import Config from "../config";
import CustomButton from "./CustomButton.vue";
import CustomParagraph from "./CustomParagraph.vue";

export default {
  components: { CustomButton, CustomParagraph },
  data() {
    return {
      start: Config.start,
    };
  },
  methods: {
    getImgUrl(img) {
      return require("../assets/images/" + img);
    },
  },
};
</script>

<style scoped>
.start-image {
  width: 100%;
  object-fit: contain;
}

.text-area {
  padding: 30px 40px;
}

.start-text {
  color: var(--quiz-text-color);
  margin: 25px 0;
}

.button-area {
  text-align: center;
  margin-top: 25px;
}
</style>
